import type { HeadingBlock as Block } from './types'
import { BlockShell } from './BlockShell'
import { TextBlockBase } from './TextBlockBase'
import type { BlockAction } from './BlockActionsMenu'

interface Props {
  block: Block
  selected: boolean
  frozen: boolean
  animate: boolean
  actions: BlockAction[]
  onTextChange: (id: string, text: string) => void
  onToggleSelect: (id: string) => void
}

export function HeadingBlockView({
  block,
  selected,
  frozen,
  animate,
  actions,
  onTextChange,
  onToggleSelect,
}: Props) {
  const Tag = (block.level === 3 ? 'h3' : 'h2') as 'h2' | 'h3'
  return (
    <BlockShell
      blockId={block.id}
      slug={block.slug}
      selected={selected}
      frozen={frozen}
      animate={animate}
      actions={actions}
      onToggleSelect={onToggleSelect}
      editable
    >
      <TextBlockBase
        as={Tag}
        readOnly={frozen}
        value={block.text}
        onChange={(next) => onTextChange(block.id, next)}
        className={Tag === 'h2' ? 'text-xl font-semibold' : 'text-lg font-semibold'}
      />
    </BlockShell>
  )
}
